import { BaseMapper } from '@ps/utils';
import { SurveyActivityLogEntry } from '@ps/survey-utils';

import { SurveyActivityLogEntryDto } from '../survey-activity-log-list.dto';

export class SurveyActivityLogEntryMapper extends BaseMapper<
  SurveyActivityLogEntryDto,
  SurveyActivityLogEntry
> {
  public fromDto(dto: SurveyActivityLogEntryDto): SurveyActivityLogEntry {
    return {
      surveyId: dto.survey_id,
      userId: dto.user_id,
      userEmail: dto.user_email,
      username: dto.username,
      message: dto.message,
      category: dto.category,
      feature: dto.feature,
      timestamp: dto.timestamp,
      surveyStatus: dto.survey_status,
      notificationType: dto.notification_type,
    };
  }
}
